import { useState, useEffect, } from 'react';
import { OderCardHeader } from '../OrderComponents.jsx';
import { giftCardService } from '../../../../../services/giftCardService.js';
import { currencyRateService } from '../../../../../services/currencyRateService.js';
import { paymentsService } from '../../../../../services/paymentsService.js';
import { productService } from '../../../../../services/productService.js';
import {
  giftCardPaymentsHeader
} from '../../../../../assets/helpers/tables.js';

import {
  paymentTypeOptions as paymentTypesOptions,
} from '../../../../../assets/helpers/options.js';
import { notify } from '../../../../../assets/helpers/toast';
import { ActionButton } from '../../../../common/Buttons/Buttons.jsx';
import { EditPaymentModal } from '../../../../common/Modals/Modals';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../../../assets/schemas/schemas';


import '../OrderComponent.scss';

export const GiftCardPayments = (props) => {
  const { label, membership, } = props;


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
  } = useForm({
    resolver: yupResolver(schemas.editPaymentSchema()),
  });


  const [paymentMethods, setPaymentMethods] = useState([]);

  const { giftcardId } = useParams();


  const [open, setOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [dollarByDate, setDollarByDate] = useState('');


  const [openEditPaymentModal, setOpenEditPaymentModal] = useState({
    isOpen: false,
    payment: '',
  });

  const [giftCards, setGiftcards] = useState([]);
  const [creationDate, setCreationDate] = useState('');

  const handleEditAmountChange = () => {
    setValue('amountBsS', (watch('amount') * dollarByDate)?.toFixed(2));
  };


  const handleDateChange = (e) => {
    setCreationDate(e);
    getDollarRateByDate(e);
  };

  const getDollarRateByDate = (date) => {
    let params = {
      currency: 'USD',
      date: moment(date).format('YYYY-MM-DD'),
      limit: 20,
    };

    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          setDollarByDate(response?.data?.result[0]?.rate);
          setValue(
            'amountBsS',
            (watch('amount') * response?.data?.result[0]?.rate)?.toFixed(2)
          );
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => { });
    return true;
  };

  const editPayment = handleSubmit(async (data) => {
    const formData = new FormData();
    formData.append('giftCard', openEditPaymentModal?.payment?.giftCard);
    formData.append(`payments[0][id]`, openEditPaymentModal?.payment?._id);
    formData.append(`payments[0][method]`, watch(`method`));
    formData.append(`payments[0][reference]`, watch(`reference`));
    formData.append(`payments[0][amount]`, watch(`amount`));
    formData.append(`payments[0][amountBsS]`, watch(`amountBsS`));
    formData.append(
      `payments[0][date]`,
      moment(creationDate)?.format('YYYY-MM-DD')
    );
    if (watch('bank')) {
      formData.append(`payments[0][bank]`, watch(`bank`));
    }
    if (watch(`phone`)) {
      const rawPhone = watch('phone') || '';
      const phone = String(rawPhone).replace(/\+/g, '');
      formData.append(`payments[0][phone]`, phone);
    }
    if (membership?.paymentType === 'Cashea') {
      formData.append(
        `payments[0][referenceCashea]`,
        watch(`referenceCashea`)
      );
    }

    if (!isLoading && formData) {
      setIsLoading(true);
      paymentsService
        .editGiftcardPayment(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago editado con exito`, 'success');
            handleEditPaymentModal();
            setIsLoading(false);
            // reloadMembership();
            preloadEditForm(giftcardId);

          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });



  const handleEditPaymentModal = (payment) => {
    setOpenEditPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: !openEditPaymentModal?.isOpen,
        payment: payment ? payment : '',
      };
    });

    if (payment) {
      setValue('amount', payment?.totalAmount);
      setValue('amountBsS', payment?.totalAmountInBsS?.toFixed(2));
      setValue('reference', payment?.reference);
      setValue('referenceCashea', payment?.referenceCashea);
      setValue('method', payment?.method?._id);
      let fecha = new Date(payment?.createdAt);
      setCreationDate(fecha?.setDate(fecha.getDate()));
    }
  };



  const preloadEditForm = (giftcardId) => {
    giftCardService
      .getGiftcardSales(giftcardId)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setGiftcards(response?.data?.sale || []);

        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });

  }

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };


  useEffect(() => {
    getDollarRateByDate(new Date());
    getPaymentMethods()
    preloadEditForm(giftcardId);
  }, []);

  return (
    <>

      <EditPaymentModal
        modal={openEditPaymentModal}
        register={register}
        action={editPayment}
        handleClose={() => handleEditPaymentModal()}
        // payRewenMembership={Paymentaction()}
        paymentType={membership?.paymentType}
        errors={errors}
        setValue={setValue}
        control={control}
        options={{
          paymentMethods: paymentMethods,
          paymentTypesOptions: paymentTypesOptions,
          dollarRate: dollarByDate,
        }}
        creationDate={creationDate}
        onChange={{
          handleEditAmountChange: handleEditAmountChange,
          handleDateChange: handleDateChange,
        }}
        watch={watch}
      />
      <div className="col-12">
        <div className="order-card">
          <OderCardHeader open={open} setOpen={setOpen} label={label} />

          {open && (
            <>
              <br />
              <table className="table">
                <tr>
                  {giftCardPaymentsHeader?.map((h) => (
                    <th key={h?.name}>{h?.name}</th>
                  ))}
                </tr>
                {giftCards?.payments?.length > 0 &&
                  giftCards?.payments?.map((d) => {
                    return (
                      <tr key={d?._id}>
                        <td>TIPO</td>
                        <td>{d?.totalAmount}</td>
                        <td>{d?.totalAmountInBsS}</td>
                        <td>{d?.method?.method}</td>
                        <td>{d?.status}</td>
                        <td>{d?.reference}</td>
                        <td>
                          {d?.accHolder && d?.accHolder !== 'undefined'
                            ? d?.accHolder
                            : ''}
                        </td>
                        <td>{d?.cashReceiver || ''}</td>
                        <td>
                          {d?.referenceImg && (
                            <a
                              style={{ padding: '0px' }}
                              target="_blank"
                              href={d?.referenceImg}
                              rel="noreferrer"
                            >
                              Ver Comprobante
                            </a>
                          )}
                        </td>
                        <td>{d?.createdAt ? moment(d?.createdAt).format('DD/MM/YYYY') : ''}</td>
                        <td>
                          <ActionButton
                            label="Editar"
                            action={() => handleEditPaymentModal(d)}
                          /></td>
                        <td></td>
                      </tr>
                    );
                  })}
              </table>

            </>
          )}
        </div>
      </div>
    </>
  );
};
